module.exports = __webpack_public_path__ + "static/media/page-button.2f820e5c.png";